import * as API_CONSTANT from '../constants'

export const getLocationTrackingGetAll = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/get/all`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({})
    })
    .then(res => res.json())
)

export const getLocationTrackingBatchByPlates = (plates) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/batch/get/plate`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            plates
        })
    })
    .then(res => res.json())
)

export const getLocationTrackingThruUID = (uid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/get/uid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            uid
        })
    })
    .then(res => res.json())
)

export const createLocationTracking = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const updateLocationTracking = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const getTrackLinkByTRACKID = (trackid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/tracking/link/get/trackid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            trackid
        })
    })
    .then(res => res.json())
)